import React from 'react';

interface LinkPreviewProps {
  url: string;
}

const LinkPreview: React.FC<LinkPreviewProps> = ({ url }) => {
  if (!url || typeof url !== 'string') {
    return null;
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="text-primary underline hover:text-primary/80 break-all"
    >
      {url}
    </a>
  );
};

export default LinkPreview;